/**
 * Hosts that must not be stored as `brewery.website`. Linktree is allowed.
 * Keep in sync with backend `domain/socials/socialHost.ts`.
 */
const SOCIAL_PLATFORM_HOST_SUFFIXES = {
  facebook: ['facebook.com'],
  instagram: ['instagram.com'],
  twitter: ['twitter.com', 'x.com'],
  yelp: ['yelp.com'],
  tripadvisor: ['tripadvisor.com'],
  tiktok: ['tiktok.com'],
};

const BLOCKED_BREWERY_WEBSITE_SOCIAL_TYPES = Object.freeze(
  Object.keys(SOCIAL_PLATFORM_HOST_SUFFIXES),
);

function normalizeSocialHostname(hostname) {
  return hostname.trim().toLowerCase().replace(/^www\./, '').replace(/^m\./, '');
}

function hostnameMatchesSuffix(hostname, suffix) {
  return hostname === suffix || hostname.endsWith(`.${suffix}`);
}

function parseWebsiteHostname(websiteUrl) {
  if (typeof websiteUrl !== 'string' || !websiteUrl.trim()) {
    return null;
  }
  const trimmed = websiteUrl.trim();
  const candidates = /^https?:\/\//i.test(trimmed)
    ? [trimmed]
    : [`https://${trimmed}`, trimmed];
  for (const candidate of candidates) {
    try {
      return new URL(candidate).hostname;
    } catch {
      // try the next candidate
    }
  }
  return null;
}

export function socialPlatformTypeFromWebsiteUrl(websiteUrl) {
  const hostname = parseWebsiteHostname(websiteUrl);
  if (!hostname) {
    return null;
  }
  const normalized = normalizeSocialHostname(hostname);
  for (const platformType of BLOCKED_BREWERY_WEBSITE_SOCIAL_TYPES) {
    const suffixes = SOCIAL_PLATFORM_HOST_SUFFIXES[platformType];
    if (suffixes.some((suffix) => hostnameMatchesSuffix(normalized, suffix))) {
      return platformType;
    }
  }
  return null;
}

export function isBlockedAsBreweryWebsiteUrl(websiteUrl) {
  return socialPlatformTypeFromWebsiteUrl(websiteUrl) !== null;
}
